import { DefendOptionType } from '../types/defend-option-type'

export class DefendOption {
  public constructor(public readonly defendOptionType: DefendOptionType) {}

  public getDefendOptionName(): string {
    if (this.defendOptionType === 'PassDefend') {
      return $localize`:Defender option name:Pass defend`
    }

    if (this.defendOptionType === 'Defend') {
      return $localize`:Defender option name:Defend`
    }

    if (this.defendOptionType === 'CallOtherDefender') {
      return $localize`:Defender option name:Call`
    }

    if (this.defendOptionType === 'DefendAlone') {
      return $localize`:Defender option name:Defend alone`
    }

    if (this.defendOptionType === 'Counter') {
      return $localize`:Defender option name:Counter`
    }

    if (this.defendOptionType === 'Recounter') {
      return $localize`:Defender option name:Recounter`
    }

    if (this.defendOptionType === 'NoCounter') {
      return $localize`:Defender option name:No counter`
    }

    if (this.defendOptionType === 'NoRecounter') {
      return $localize`:Defender option name:No recounter`
    }

    throw new Error(
      `Unable to get defender option name for defender option ${this.defendOptionType}`,
    )
  }
}

export const defendOptionNull: DefendOption = new DefendOption('PassDefend')
